/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraServiceManagementChangeManagementConfigurationMappingForCostRecommendation extends models.JiraServiceManagementChangeManagementConfigurationMapping {
    getFixupPrototypeFunction() { return JiraServiceManagementChangeManagementConfigurationMappingForCostRecommendation.fixupPrototype; }

    static newInstance(model: Partial<JiraServiceManagementChangeManagementConfigurationMappingForCostRecommendation>): JiraServiceManagementChangeManagementConfigurationMappingForCostRecommendation {
        let obj = Object.assign(new JiraServiceManagementChangeManagementConfigurationMappingForCostRecommendation(), model);
        JiraServiceManagementChangeManagementConfigurationMappingForCostRecommendation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraServiceManagementChangeManagementConfigurationMappingForCostRecommendation>): JiraServiceManagementChangeManagementConfigurationMappingForCostRecommendation {
        if (!model) return null;
        return JiraServiceManagementChangeManagementConfigurationMappingForCostRecommendation.newInstance(<JiraServiceManagementChangeManagementConfigurationMappingForCostRecommendation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraServiceManagementChangeManagementConfigurationMappingForCostRecommendation) {
        if (!obj) return;

        models.JiraServiceManagementChangeManagementConfigurationMappingForCostRecommendation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraServiceManagementChangeManagementConfigurationMappingForCostRecommendation): boolean {
        if (models.JiraServiceManagementChangeManagementConfigurationMapping.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, JiraServiceManagementChangeManagementConfigurationMappingForCostRecommendation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Allowed attributes for Cost Recommendation Description
     */
    value: models.DescriptionAttributeForChangeManagementForCostRecommendation;

    value_direct: string;

}
